import styled from 'styled-components';

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 32px;

  .danger {
    color: ${({ theme }) => theme.danger_500};
  }
`;
